<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent="save">
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-plus" @click="buttonClickEventApproval('Y')">
              선택승인
            </el-button>
            <el-button type="danger" icon="el-icon-delete-solid" @click="buttonClickEventApproval('N')">
              승인취소
            </el-button>
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="12">
              <el-row>
                <el-form-item label="처리기간" label-width="100px">
                  <el-col :span="24">
                    <el-date-picker type="date" placeholder="시작일" v-model="form.startDt" style="width: 38%;" value-format="yyyy-MM-dd"></el-date-picker>
                    <span style="margin: 0 11px 0 11px;">-</span>
                    <el-date-picker type="date" placeholder="종료일" v-model="form.endDt" style="width: 38%;" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-form-item label="승인여부" label-width="100px">
                <el-select v-model="form.confirmYn">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['confirmYn']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="처리구분" label-width="100px">
                <el-select v-model="form.squareType">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['squareType']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="지역/센터" label-width="100px">
                <el-select v-model="form.catId" @change="onCatIdChange">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['catId']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="form.subCatId" v-show="changeCatIdShow">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['subCatId']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :context="context"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                :enableRangeSelection="true"
                :suppressMiniFilter="true"
                @grid-ready="onReadyMain"
                @cell-clicked="onCellClicked" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import ReceptionModal from "@/components/AS/CallDispose/Modal/ReceptionModal";
import InstallTreat from "@/components/AS/InstallList/InstallTreat";
import BsMaTreat from "@/components/AS/BsmaList/BsMaTreat";

import mixin from "@/mixin/lucoms";


function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  props: {
  },
  mixins: [mixin],
  data() {
    return {
      data: [],
      form: {
        companyId : '',
        startDt: this.$moment().subtract(1, 'months').add(1, 'days').format('YYYY-MM-DD'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        confirmYn : '',
        squareType : '',
        catId : '',              // 지역
        subCatId: '',            // 지역 상세
        sortType : '',           // 승인/정산처리유형
        page : 1,
        totalPage : 9999,
        curPage : 0,
        totalCount : 9999,
        processTime : ''
      },
      combos: {
        'confirmYn' : [],
        'squareType' : [],
        'catId' : [],
        'subCatId' : []         //지역상세
      },
      //startDt: this.$moment().add(-1, 'month').startOf('month').format('YYYY-MM-DD'),
      //endDt: this.$moment().format('YYYY-MM-DD'),
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 40px; width: 100%;height: 700px; min-height:100px;',
      defaultColDef: {
        flex: 1
        , resizable: true
        , filter:true
        , sortable: true
        , cellDataType: false
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      context: {
        //checkbox 전체 체크 이벤트 추가
        headerAllCheckEvent: this.allCheckEvnet
      },
      columnDefs: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
      changeCatIdShow : false
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;
      
      this.init();
    },
    createMainColumnDefs() {
      this.columnDefs = [
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {
          field: 'chk',
          width: 80,
          headerComponent: `checkBox`,
          headerComponentParams: (params) => {
            return params;
          },
          cellRenderer: 'checkBox',
          cellRendererParams: (params) => {
            return {trueValue: 'Y', falseValue: 'N', disable: (params.data.squareYn === 'Y') || (params.data.squareYn == '') }
          }
        },
        {headerName:'지역', field:'areaNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'처리센터', field:'asAgentNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'처리일시', field:'procDt', width:120, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            return params.value = params.value === null  ? '' : this.getDateFormat(`${params.value}`) ;
          }},
        {headerName:'처리자', field:'userNm', cellStyle:{textAlign: 'center'}, width:160},
        {headerName:'처리구분', field:'squareTypeNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'접수(의뢰)번호', field:'squareId', width:150, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
          }
        },
        {headerName:'사이트명', field:'siteNm', width:250 },
        {headerName:'고객명', field:'custNm', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'승인구분', field:'confirmYn', width:110, cellStyle:{textAlign: 'center'},
          valueGetter: (params) => {
            return params.data.confirmYn === 'Y' ? "승인" : "미승인"
          }
        },
        {headerName:'정상구분', field:'squareYn', width:110, cellStyle:{textAlign: 'center'},
          valueGetter: (params) => {
            return params.data.squareYn === 'Y' ? "정산" : "미정산"
          }},
      ];
    },
    onCellClicked(params) {
      //const idx = params.rowIndex;
      const field = params.colDef.field;
      if(field === 'squareId') {

        if(params.data.squareType === 'As') {
          this.openModalAs(params.data);

        } else if(params.data.squareType === 'BsMa') {
          const vForm = {
            companyId : this.form.companyId,
            mstType : 'Proc',
            requestId: params.data.squareId
          }
          this.$http.post(_url("/api/workMng/bsMaEdit/selectList"), vForm)
              .then(response => {
                let responseData = response.data;
                responseData.uvwBsMaItemM[0].confirmYn = params.data.confirmYn;
                responseData.uvwBsMaItemM[0].type = 'Approval';
                this.openModalBsMa(responseData);
              }).finally(() => {
            this.$store.commit('finish')
          });

        } else if(params.data.squareType === 'SetUp') {
          const vForm = {
            companyId : this.form.companyId,
            requestId: params.data.squareId,
            asAgentId : params.data.asAgentId,
            processTime : ''
          }
          this.$http.post(_url("/api/agent/InstallAgnet/detail/item"), vForm)
              .then(response => {
                response.data.modelSetupSelItem1[0].type = (params.data.squareType === "SetUp" || params.data.squareType === "BsMa") ? "Approval" : '';
                this.openModalSetup(response.data);
              }).finally(() => {
            this.$store.commit('finish')
          });
        }
      }
    },
    /**
     * AS 상세 팝업(As) 오픈
     */
    openModalAs(param) {
      let vm = this;

      this.$modal.open({
        width: 800,
        component: ReceptionModal,
        parent: this,
        props: {
          data: {
            asId: param.squareId,
            custId: param.custId,
            sortType: '',
            popHeadInfo: {}, //this.custParam.popHeadInfo,
            //reqDt: this.$moment('20230101').format('YYYY-MM-DD'),
            recptDt: this.$moment(param.callDt).format('YYYY-MM-DD'),
            procsDt: this.$moment(param.procDt).format('YYYY-MM-DD'),
            menuGubun : 'ApprovalList'
          }
        },
        events: {
          close(data) {
          },
        }
      });
    },
    /**
     * BS/MA 상세 팝업(BsMa) 오픈
     */
    openModalBsMa(param) {
      this.$modal.open({
        width: 800,
        component: BsMaTreat,
        parent: this,
        props: {
          data: param
        },
        events: {
          close(data) {
          },
        }
      });
    },
    /**
     * 설치 상세 팝업(Setup) 오픈
     */
    openModalSetup(param) {
      let vm = this;
      this.$modal.open({
        width: 800,
        component: InstallTreat,
        parent: this,
        props: {
          data: param
        },
        events: {
          close(data) {
          },
          goOpen(){
            vm.goOpen();
          }
        }
      });
    },
    $dismiss() {
      this.$emit('dismiss')
      this.$parent.close()
    },
    goOpen() {
      let that = this
      this.$store.commit('loading')

      const vForm = {
        companyId :this.form.companyId,
        startDt: this.form.startDt,
        endDt: this.form.endDt,
        confirmYn : this.form.confirmYn,
        squareType : this.form.squareType,
        catId : (this.form.subCatId.length <= 0 || this.form.subCatId === '')  ? (this.form.catId === '' ? 0 : this.form.catId) : this.form.subCatId, // 지역
        subCatId: this.form.subCatId, // 지역 상세
        sortType : this.form.sortType,
        page : this.form.page,
        totalPage : this.form.totalPage,
        curPage : this.form.curPage,
        totalCount : this.form.totalCount,
        processTime : this.form.processTime
      }

      this.$http.post(_url("/api/workMng/approval/list"), vForm).then(response => {
        this.data = response.data
        /* data customize */
        this.changeData();
      }).finally(() => {
        this.$store.commit('finish')
      });
    },
    // 선택승인, 선택승인취소
    buttonClickEventApproval(status) {
      let vm = this;
      var txtQuestion;
      var txtSuccess;
      var txtFail;

      if(status === 'Y') {
        txtQuestion = '선택한 항목을 승인 하시겠습니까?'
        txtSuccess = '승인되었습니다.'
        txtFail = '승인할 항목을 선택하세요.'
      } else {
        txtQuestion = '선택한 항목을 취소 하시겠습니까?'
        txtSuccess = '승인취소되었습니다.'
        txtFail = '승인취소할 항목을 선택하세요.'
      }

      const result = this.data.filter(v => v.chk === 'Y').map(x => {
        x.yesNo = status
        return x
      });

      if(result.length > 0){
        this.$swal({
          type: 'question',
          text: txtQuestion,
          showCancelButton: true
        }).then(r => {
          if (r.value) {
            this.$store.commit('loading')
            this.$http.post(_url(`/api/workMng/approval/procCheckedApproval`), result)
                .then((response) => {
                  this.$swal({ type: 'success', text: txtSuccess })
                      .then((result) => {
                        if (result.value) this.goOpen();
                      });
                }).catch((e) => {
              this.$swal({ type: 'warning', text: '실패되었습니다' })
            }).finally(() => {
              this.$store.commit('finish')
            });
          }
        })
      } else {
        this.$swal({ type: 'info', text: txtFail });
      }
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/workMng/approval/init`)
          .then(response => {
            this.combos['confirmYn'] = response.data.confirmYn;
            this.combos['squareType'] = response.data.squareType;
            this.combos['catId'] = response.data.catId;
          }).finally(() => {
            this.goOpen();
            this.$store.commit('finish');
          });

      this.createMainColumnDefs();
    },
    onCatIdChange(param){
      this.form.subCatId = '';
      if(param === '') this.changeCatIdShow =  false;
      else{
        this.changeCatIdShow =  true;
        // 지역 상세
        this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: param} })
            .then(response => {
              this.combos['subCatId'] = response.data || []
            });
      }
    },
    /* data customize */
    changeData(){
      this.data.map((x, i) => {
        let filterSquareType = this.combos['squareType'].filter(y => y.key === x.squareType);
        x.squareTypeNm = filterSquareType[0].value;
      })
    },
    /**
     * grid 내에 체크박스 전체 체크 함수
     * @param {*} field 
     * @param {*} checked 
    */
    allCheckEvnet(field, checked) {
      return this.data = this.data.map(x => {
          if(x.squareYn !== 'Y' || x.squareYn !== '') {
              x[field] = checked ? 'Y' : 'N';
          }
          return x;
      })
    },
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    this.form.companyId = this.$store.state.loginInfo.compCd;

  },
  beforeMount() {
    this.createMainColumnDefs();
  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>


<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>